import { gql } from '@/lib/graphql/gql'

export const USER_NAV_QUERY = gql`
  query UserNav {
    user {
      id
      firstName
      lastName
      fullName
      email
      image
    }
  }
`
